module.exports = __webpack_public_path__ + "images/kihnu/routes/SOR-TRI-SOR.png";